var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg81(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2843)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0806 20.15C17.2506 20.15 16.6106 19.93 16.1606 19.49C15.7206 19.04 15.5006 18.395 15.5006 17.555V16.625C15.5006 16.105 15.5856 15.67 15.7556 15.32C15.9256 14.96 16.2006 14.68 16.5806 14.48V14.45C16.2306 14.26 15.9706 14 15.8006 13.67C15.6406 13.33 15.5606 12.9 15.5606 12.38V11.945C15.5606 11.105 15.7756 10.465 16.2056 10.025C16.6456 9.575 17.2706 9.35 18.0806 9.35C18.8906 9.35 19.5106 9.575 19.9406 10.025C20.3806 10.465 20.6006 11.105 20.6006 11.945V12.38C20.6006 13.38 20.2606 14.07 19.5806 14.45V14.48C19.9606 14.68 20.2356 14.96 20.4056 15.32C20.5756 15.67 20.6606 16.105 20.6606 16.625V17.555C20.6606 18.395 20.4356 19.04 19.9856 19.49C19.5456 19.93 18.9106 20.15 18.0806 20.15ZM18.0806 13.775C18.6606 13.775 18.9506 13.425 18.9506 12.725V11.9C18.9506 11.2 18.6606 10.85 18.0806 10.85C17.5006 10.85 17.2106 11.2 17.2106 11.9V12.725C17.2106 13.425 17.5006 13.775 18.0806 13.775ZM18.0806 18.65C18.7006 18.65 19.0106 18.255 19.0106 17.465V16.46C19.0106 15.67 18.7006 15.275 18.0806 15.275C17.4606 15.275 17.1506 15.67 17.1506 16.46V17.465C17.1506 18.255 17.4606 18.65 18.0806 18.65ZM21.7014 18.41H23.2914V20H21.7014V18.41ZM26.8386 11.99H25.1136V10.82C25.5836 10.82 25.9586 10.78 26.2386 10.7C26.5286 10.62 26.7586 10.49 26.9286 10.31C27.0986 10.12 27.2486 9.85 27.3786 9.5H28.4886V20H26.8386V11.99Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2843",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2843",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg81);
export default __webpack_public_path__ + "static/media/81.da0769ced8fa8bb29c7857ec39f02911.svg";
export { ForwardRef as ReactComponent };